import type { NavItem } from '@kangaroo/ui';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import TabletMacOutlinedIcon from '@mui/icons-material/TabletMacOutlined';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { canViewAdmin } from '../../lib/adminAccess';

export const ADMIN_SECTIONS = [
  { id: 'overview', label: 'Overview', icon: <AdminPanelSettingsOutlinedIcon /> },
  { id: 'billing', label: 'Billing', icon: <ReceiptLongOutlinedIcon /> },
  { id: 'teams', label: 'Teams', icon: <GroupsOutlinedIcon /> },
  { id: 'users', label: 'Users', icon: <PersonOutlineIcon /> },
  { id: 'features', label: 'Features', icon: <TuneOutlinedIcon /> },
  { id: 'communications', label: 'Email campaigns', icon: <CampaignOutlinedIcon /> },
  { id: 'circuits', label: 'Circuits', icon: <MapOutlinedIcon /> },
  { id: 'kiosks', label: 'Kiosks', icon: <TabletMacOutlinedIcon /> },
  { id: 'sessions', label: 'Session alerts', icon: <FlagOutlinedIcon /> },
  { id: 'uploads', label: 'Uploads', icon: <CloudUploadOutlinedIcon /> },
  { id: 'feedback', label: 'Feedback', icon: <FeedbackOutlinedIcon /> },
  { id: 'help', label: 'Help desk', icon: <HelpOutlineIcon /> },
  { id: 'docs', label: 'Docs', icon: <DescriptionOutlinedIcon /> },
  { id: 'emails', label: 'Emails', icon: <MailOutlineIcon /> },
] as const;
export type AdminSection = typeof ADMIN_SECTIONS[number]['id'];
export const adminSectionPath = (section: AdminSection) => section === 'overview' ? '/admin' : `/admin/${section}`;
export const resolveAdminSection = (value: string | null | undefined): AdminSection => ADMIN_SECTIONS.find(item => item.id === value)?.id ?? 'overview';

export function adminNavigation(user: { email: string } | null | undefined): NavItem[] {
  if (!canViewAdmin(user)) return [];
  return [{ label: 'Admin', path: '/admin', icon: <AdminPanelSettingsOutlinedIcon />, tooltip: 'Admin', children: [
    ...ADMIN_SECTIONS.map(section => ({ label: section.label, path: adminSectionPath(section.id),
      ...(section.id === 'billing' ? { activePaths: ['/admin/teams/'] } : {}) })),
    { label: 'Track catalog', path: '/admin/track-catalog' },
    { label: 'Circuit maker', path: '/admin/circuit-maker' },
  ] }];
}
